import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import {
  Autocomplete,
  Button,
  Chip,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
} from "@mui/material";
import { ADMIN_AUDIT, APP_BASE_URL } from "../../../Common/EndPoints";
import DataTable from "../../../Components/DataGrid/DataGrid";
import { getParsedLocalStorage } from "../../../Utils/storage-utils";
import { extractParsedDataFromPermissions } from "../../../Utils/Utils";
import { useSelector } from "react-redux";
import { selectedCustomersSelector } from "../../authentication/auth-slice";
import { useImmer } from "use-immer";
import { AutocompleteStationListPop } from "../../../Components/AutocompleteStationListPop/AutocompleteStationListPop";
import ConfirmationModal from "../../../Modal/ConfirmationModal";
import toast from "react-hot-toast";

async function getRtuHealth(params) {
  const response = await axios.get(APP_BASE_URL + "/v1/health", { params });
  return response.data.data;
}

const initialPaginantion = {
  pageIndex: 0,
  pageSize: 20,
  totalRowCount: 0,
};
const intitFilters = {
  tokenLike: "",
  is_verified: null,
  zone_ids: [],
  div_ids: [],
  customer_ids: [],
};
let initialConfirmationModal = {
  open: false,
  message: "",
  des: "",
  updateValue: null,
  isLoading: false,
};

const HealthMonitoringManagement = () => {
  const user_permissions = getParsedLocalStorage("permissions");
  const parsedPermissions = useMemo(() => {
    return extractParsedDataFromPermissions(user_permissions);
  }, []);
  const selectedCustomersList = useSelector(selectedCustomersSelector);
  const permittedCustomerIds = useMemo(() => {
    const _list = selectedCustomersList;
    if (!_list) return [];
    return _list.map((customer) => customer.customerId);
  }, [selectedCustomersList]);
  const [state, setState] = useState({ rows: [], loading: false });
  const [pagination, setPagination] = useState(initialPaginantion);
  const [filters, setFilters] = useImmer(intitFilters);
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  const [confirmationModal, setConfirmationModal] = useImmer(initialConfirmationModal);

  const zone_dd = useMemo(() => {
    return parsedPermissions.zones;
  }, []);

  const div_dd = useMemo(() => {
    let total_divs = parsedPermissions.divisions;
    if (filters.zone_ids.length) {
      const ids = filters.zone_ids.map((obj) => obj.id);
      total_divs = parsedPermissions.divisions.filter((div_obj) => ids.includes(div_obj.zone.id));
      const filtered_form_div_ids = filters.div_ids.filter((selected_div_obj) => {
        return total_divs.find((obj) => obj.id === selected_div_obj.id);
      });
      setFilters((prev) => {
        prev.div_ids = filtered_form_div_ids;
      });
    }

    return total_divs;
  }, [filters.zone_ids]);
  const customer_dd = useMemo(() => {
    let filtered_stations = parsedPermissions.stations.filter((obj) => permittedCustomerIds.includes(obj.id));
    if (filters.div_ids.length) {
      const selected_div_ids = filters.div_ids.map((obj) => obj.id);
      filtered_stations = filtered_stations.filter((stationObj) => selected_div_ids.includes(stationObj.division.id));
    } else if (filters.zone_ids.length) {
      const selected_zone_ids = filters.zone_ids.map((obj) => obj.id);
      filtered_stations = filtered_stations.filter((stationObj) => selected_zone_ids.includes(stationObj.zone.id));
    }
    const filtered_form_stn_ids = filters.customer_ids.filter((selected_stn_obj) => {
      return filtered_stations.find((obj) => obj.id === selected_stn_obj.id);
    });
    setFilters((prev) => {
      prev.customer_ids = filtered_form_stn_ids;
    });
    return filtered_stations;
  }, [permittedCustomerIds, filters.div_ids, filters.zone_ids]);
  const columns = [
    {
      field: "token",
      headerName: "Token",
      sortable: true,
      minWidth: 110,
      hideable: true,
      flex: 1,
    },
    {
      field: "verified",
      headerName: "Verified Status",
      sortable: true,
      minWidth: 110,
      hideable: true,
      flex: 1,
      renderCell: (param) => {
        const is_varified = Boolean(param.value);
    
          const token = param.row.token;
          const handleChange = (event) => {
            setConfirmationModal((prev) => {
              prev.open = true;
              prev.message = `Token - ${token}`;
              prev.des = is_varified
                ? `Token ${token} will be set to "Not Verified"`
                : `Token ${token} will be set to "Verified"`;
              prev.updateValue = { token, verified: !is_varified };
            });
          };

          return (
            <div className="ml-1">
              <FormControlLabel

                // required
                control={
                  <Switch
                    checked={is_varified}
                    onChange={handleChange}
                    slotProps={{ input: { "aria-label": "controlled" } }}
                  />
                }
                label={is_varified ? "Verified" : "Not Verified"}
              />
            </div>
          );
    
      },
    },
  ];

  //   useEffect(() => {
  //     const handler = setTimeout(() => {
  //       setDebouncedFilters(filters);
  //     }, 500);

  //     return () => {
  //       clearTimeout(handler);
  //     };
  //   }, [filters]);

  async function getData(_filters) {
    setState((_state) => ({ ..._state, loading: true }));
    try {
      const response = await getRtuHealth({
        page: pagination.pageIndex,
        pageSize: pagination.pageSize,
        tokenLike: _filters?.tokenLike,
        isVerified: _filters?.is_verified?.id,
        stations: _filters?.customer_ids?.length
          ? _filters?.customer_ids?.map((opt) => opt.value).toString()
          : customer_dd.map((opt) => opt.value).toString(),
      });

      const { content, totalElements } = response;
      setState((_state) => ({
        ..._state,
        rows: content.map((_record, index) => ({ ..._record, id: index })),
      }));
      setPagination((_state) => ({ ..._state, totalRowCount: totalElements }));
    } catch (error) {
      setState((_state) => ({ ..._state, rows: [] }));
      setPagination((_state) => ({ pageIndex: 0, pageSize: 20, totalRowCount: 0 }));
    } finally {
      setState((_state) => ({ ..._state, loading: false }));
    }
  }
  const verified_filter_options = [
    // { id: null, label: "All" },
    { id: true, label: "Verified" },
    { id: false, label: "Not Verified" },
  ];

  useEffect(() => {
    getData(filters);
  }, [pagination.pageIndex, pagination.pageSize]);

  const handleConfirm = async (updationValue) => {
    const { token, verified } = updationValue;
    try {
      setConfirmationModal((prev) => {
        prev.isLoading = true;
      });
      if (!token || ![true, false].includes(verified)) {
        throw new Error("Invalid Update Params");
      }
      const params = {
        verified: Boolean(verified),
        token: token
      };
      const response = await axios.put(APP_BASE_URL + "/v1/health/update" , null,{
        params,
      });
      
      toast.success("Token Status Updated Successfully");
      getData(filters);
    } catch (err) {
      toast.error(err?.message ?? "Something Went wrong");
    } finally {
      setConfirmationModal(initialConfirmationModal);
    }
  };

  return (
    <div className="h-full w-full bg-white p-2">
      <h3>Health Monitoring Management</h3>
      <div className="flex items-center gap-2 mb-2">
        <Autocomplete
          isOptionEqualToValue={(option, value) => option.id === value.id}
          multiple
          size="small"
          sx={{ width: "18em" }}
          options={zone_dd ?? []}
          value={filters.zone_ids || []}
          onChange={(_, newValue) => {
            setFilters((prev) => {
              prev.zone_ids = newValue;
            });
          }}
          disableCloseOnSelect
          getOptionLabel={(opt) => opt.value}
          renderInput={(params) => <TextField {...params} label="Zones" />}
          renderTags={(value, getTagProps) => {
            return (
              <div>
                <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
                {value.length > 1 && (
                  <AutocompleteStationListPop title={value.map((option) => option?.value ?? "").toString()}>
                    <Chip size="small" label={`+${value.length - 1}`} />
                  </AutocompleteStationListPop>
                )}
              </div>
            );
          }}
        />
        <Autocomplete
          isOptionEqualToValue={(option, value) => option.id === value.id}
          multiple
          size="small"
          disableCloseOnSelect
          sx={{ width: "18em" }}
          options={div_dd ?? []}
          value={filters.div_ids || []}
          onChange={(_, newValue) => {
            setFilters((prev) => {
              prev.div_ids = newValue;
            });
          }}
          getOptionLabel={(opt) => opt.value}
          renderInput={(params) => <TextField {...params} label="Divisions" />}
          renderTags={(value, getTagProps) => {
            return (
              <div>
                <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
                {value.length > 1 && (
                  <AutocompleteStationListPop title={value.map((option) => option?.value ?? "").toString()}>
                    <Chip size="small" label={`+${value.length - 1}`} />
                  </AutocompleteStationListPop>
                )}
              </div>
            );
          }}
        />
        <Autocomplete
          isOptionEqualToValue={(option, value) => option.id === value.id}
          multiple
          size="small"
          sx={{ width: "18em" }}
          disableCloseOnSelect
          options={customer_dd ?? []}
          value={filters.customer_ids || []}
          onChange={(_, newValue) => {
            setFilters((prev) => {
              prev.customer_ids = newValue;
            });
          }}
          getOptionLabel={(opt) => opt.value}
          renderInput={(params) => <TextField {...params} label="Stations" />}
          renderTags={(value, getTagProps) => {
            return (
              <div>
                <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
                {value.length > 1 && (
                  <AutocompleteStationListPop title={value.map((option) => option?.value ?? "").toString()}>
                    <Chip size="small" label={`+${value.length - 1}`} />
                  </AutocompleteStationListPop>
                )}
              </div>
            );
          }}
        />
        <TextField
          label="Token"
          variant="outlined"
          placeholder="Toekn"
          value={filters.tokenLike}
          size="small"
          onChange={(event) =>
            setFilters((prev) => {
              prev.tokenLike = event.target.value;
            })
          }
        ></TextField>
        <Autocomplete
          value={filters.is_verified}
          size="small"
          isOptionEqualToValue={(opt) => opt.id === filters?.is_verified?.id}
          onChange={(event, newValue) => {
            setFilters((prev) => {
              prev.is_verified = newValue;
            });
          }}
          options={verified_filter_options}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label="Verified" />}
        />
        <Button
          variant="contained"
          onClick={() => {
            getData(filters);
          }}
        >
          Search
        </Button>
        {/* <Button
          variant="outlined"
          onClick={() => {
            setFilters(intitFilters);
            setTimeout(() => {
              getData(intitFilters);
            }, 1);
          }}
        >
          Reset
        </Button> */}
      </div>
      <DataTable
        tableInfo={{
          id: "health-monitoring-management",
          label: "Admin Health Monitoring",
          requireAuthSign: false,
          timestamp: { startTs: null, endTs: null },
        }}
        loading={state.loading}
        rowCount={pagination.totalRowCount}
        pageIndex={pagination.pageIndex}
        paginationMode="server"
        pageChange={(index) => {
          setPagination((state) => ({ ...state, pageIndex: index }));
        }}
        pageSize={pagination.pageSize}
        pageSizeChange={(size) => {
          setPagination((state) => ({ ...state, pageSize: size, pageIndex: 0 }));
        }}
        rows={state.rows}
        columns={columns}
        showFilterButton={false}
      />
      {confirmationModal && (
        <ConfirmationModal
          open={confirmationModal.open}
          onClose={() => {
            setConfirmationModal(initialConfirmationModal);
          }}
          onAction={(confirmation) => {
            if (confirmation) {
              handleConfirm(confirmationModal.updateValue);
            } else {
              setConfirmationModal(initialConfirmationModal);
            }
          }}
          message={confirmationModal.message}
          des={confirmationModal.des}
          loading={confirmationModal.isLoading}
        />
      )}
    </div>
  );
};

export default HealthMonitoringManagement;
